









import { Vue, Component, Prop, Model, Watch } from 'vue-property-decorator';

import FloatingInput from '@/components/input/FloatingInput.vue';

import { Numeric } from '@/types/common';

@Component({
    components: {
        FloatingInput,
    }
})
export default class NumberInput extends Vue {
    @Model('update:value', { required: true }) value!: Numeric;
    @Prop({ default: false }) canRemove!: boolean

    localValue = ''

    @Watch('value', {
        immediate: true,
    })
    updateLocalValue(value: number) {
        this.localValue = String(value)
    }

    update() {
        if (this.localValue === '') {
            this.$emit('update:value', '');
            return;
        }

        const normalizedValue = this.localValue.replace(',', '.');
        const value = parseFloat(normalizedValue);

        this.$emit('update:value', value);
    }

    preventLetters(event: KeyboardEvent) {
        const isValidChar = /[\d,.]/.test(event.key);

        if (!isValidChar) { 
            event.preventDefault();
        }
    }
}
